import { TransactionType } from '@shared/transactions-types';

import { isType } from './isType';

export const isRoundingSavingTransaction = isType(TransactionType.ROUNDINGUP_SAVING);
